module.exports = __webpack_public_path__ + "static/L-shape-about-us-6387c86fa4697b927db07b263d07dd7e.png";